<template>
  <nav :style="appStyleProps">
    <div class="marketplace-nav d-flex align-items-center px-4 py-5" :class="{'justify-content-between': true, 'justify-content-end': false}">
      <MarketplaceLogo class="marketplace-logo d-lg-none" />
      <div class="d-flex justify-content-end ms-auto"
        :class="{'customized-affiliate': !!affiliateCustomizations}">
        <MarketplaceSidebar class="d-lg-flex d-none" :showAppConfigNav="showAppConfigNav" />
        <AppNav :full="true" :hide-app-cta="true">
          <template #contact-chip="{ desktop }">
            <!-- Desktop only: on mobile the popover is centred by BankPullStatusChip's own media query -->
            <BankPullStatusChip class="me-3" :popover-align-end="desktop" />
          </template>
        </AppNav>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'pinia'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import AppNav from '~/components/AppNav'
import MarketplaceSidebar from '~/components/marketplace/MarketplaceSidebar'
import BankPullStatusChip from '~/components/bank-pull-status/BankPullStatusChip.vue'

export default {
  name: "MarketplaceNav",
  props: ['showAppConfigNav'],
  components: {
    MarketplaceSidebar,
    AppNav,
    BankPullStatusChip,
  },
  computed: {
    ...mapState(useAffiliateCustomizationStore, ['appStyleProps', 'affiliateCustomizations']),
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/styles/affiliate-customizations/affiliate-customizations-variables';

.marketplace-logo {
  z-index: 1001;
}

.marketplace-nav {
  width: 100vw;
  position: fixed;
  z-index: 999;
  background: $app-body-background-color !important;
  height: 85px;
  @include media-breakpoint-up(lg) {
    height: calc(90px + var(--offset-top, 0px));
  }
}
</style>
